export const blog9innerURL =
  "/blogs/future-of-polyester-yarn-in-textile-and-clothing";
export const blog10innerURL =
  "/blogs/cationic-dyeable-polyester-yarn-a-revolution-in-fancy-innovative-fabrics";
export const blog11innerURL =
  "/blogs/leveraging-technology-at-sanathan-textiles";
export const blog12innerURL =
  "/blogs/s-flex-yarn-a-sanathan-textile-stretch-yarn-product";
export const blog13innerURL =
  "/blogs/sanathan-textiles-integrated-manufacturing-facility";
export const blog14innerURL =
  "/blogs/celebrating-innovation-and-transforming-indias-textile-industry";
export const blog15innerURL =
  "/blogs/how-mr-khurshed-thanawallas-board-appointment-will-propel-sanathan-polycots-greenfield-project-in-punjab";
export const blog16innerURL =
  "/blogs/strategically-expanding-by-doubling-our-polyester-filament-yarn-capacity-in-punjab";
export const blog17innerURL =
  "/blogs/how-sanathan-textiles-is-shaping-the-future-of-yarn-manufacturing-in-punjabs-thriving-textile-ecosystem";
export const blog18innerURL =
  "/blogs/driving-textile-innovation-how-sanathan-textiles-is-using-automation-to-build-a-smart-factory-in-punjab";
export const blog19innerURL =
  "/blogs/sanathan-textiles-is-building-a-stronger-foundation-and-expanding-responsibly";
export const blog20innerURL =
  "/blogs/powering-north-indias-textile-market-to-new-heights-with-technology-and-sustainable-solutions";
export const blog21innerURL =
  "/blogs/india-eu-fta-boosts-indian-textile-exports-and-tariff-advantage-sanathan-textiles";
  export const blog22innerURL =
  "/blogs/empowering-women-through-strength-and-awareness-sanathan-textiles-womens-day-initiative";
   export const blog23innerURL ="/blogs/sanathan-textiles-hits-700-mtpd-yarn-production-at-its-punjab-plant";
export const blog24innerURL =
  "/blogs/sanathan-textiles-a-year-of-meaningful-progress-and-purpose";
export const blog25innerURL =
  "/blogs/cotton-import-duty-exemption-what-it-means-for-indias-textile-yarn-industry";
export const blog26innerURL =
  "/blogs/beyond-clothing-how-sanathans-technical-textile-expansion-strengthens-everyday-industries";
